import {
  Box,
  Typography,
  Avatar,
  InputBase,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  Badge,
  CircularProgress,
  Skeleton,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Checkbox,
  Button,
  DialogActions,
  Chip,
} from '@mui/material';
import { useState, useEffect, useRef } from 'react';
import { Send, Add, MoreVert, ArrowBack, Close, AttachFile, Image, Description, Download, PictureAsPdf, InsertDriveFile, FiberManualRecord, CheckCircle, DoneAll, Mic, Stop, PlayArrow, Pause, KeyboardArrowUp } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import CustomText, { textStyles } from "../../../../components/CustomText";
import down from "../../../../assets/Messages/down.svg";
import attachment from "../../../../assets/Messages/attachment.svg";
import send from "../../../../assets/Messages/send.svg";
import chatimage from "../../../../assets/chatimage.jpeg";
import { useTranslation } from "react-i18next";
import { useLocation,useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { BASE_URL, URL } from "../../../../components/BaseUrl";
import { decryptToken } from "../../../../Utlis/Encryption";
import AeCaChatApi from "../../../../api/aeCaChatApi";
import AeCaChatSocket from "../../../../api/aeCaChatSocket";
import GeneralMessagingApi from "../../../../api/generalMessagingApi";
import { io } from "socket.io-client";
import toast from 'react-hot-toast';
import back from "../../../../assets/back.svg";

import { 
  updateSuperAdminCount, 
  updateCompanyAdminCount,
  clearAllCounts,
} from "../../../../Redux/Slices/MessageCountSlice";

const Messages = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
const messagesEndRef = useRef(null);
  const openChatProcessedRef = useRef(false);
  const [pendingChatUser, setPendingChatUser] = useState(null);

const scrollToBottom = () => {
messagesEndRef.current?.scrollIntoView({
behavior: "smooth"
});
};

  // State management
  const [searchTerm, setSearchTerm] = useState('');
  const [userSearchTerm, setUserSearchTerm] = useState('');
  const [chatList, setChatList] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [showUserList, setShowUserList] = useState(false);
  const [selectedChatType, setSelectedChatType] = useState(null); // 'super_admin' or 'company_admin'
  const [userList, setUserList] = useState([]);
  const [isLoadingThreads, setIsLoadingThreads] = useState(false);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [isSendingMessage, setIsSendingMessage] = useState(false);
  const [showThreads, setShowThreads] = useState(false);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
  const [isUploadingFile, setIsUploadingFile] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [totalUnreadCount, setTotalUnreadCount] = useState(0);
  const [localUnreadCounts, setLocalUnreadCounts] = useState({});
  const [showUserDialog, setShowUserDialog] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [userOnlineStatus, setUserOnlineStatus] = useState({});
  const [selectedUsers, setSelectedUsers] = useState([]); // Array of selected user IDs for Company Admin
  const [bulkMessageText, setBulkMessageText] = useState(""); // Message text for bulk messaging
  const [isSendingBulkMessage, setIsSendingBulkMessage] = useState(false); // Loading state for bulk send

  // Threads pagination state
  const [threadsPage, setThreadsPage] = useState(1);
  const [hasMoreThreads, setHasMoreThreads] = useState(true);
  const [isLoadingMoreThreads, setIsLoadingMoreThreads] = useState(false);
  const [totalThreads, setTotalThreads] = useState(0);
  const THREADS_PER_PAGE = 20;

  // Messages pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreMessages, setHasMoreMessages] = useState(true);
  const [isLoadingMoreMessages, setIsLoadingMoreMessages] = useState(false);
  const [totalMessages, setTotalMessages] = useState(0);
  const MESSAGES_PER_PAGE = 15;
  const isLoadingOlderRef = useRef(false);

  useEffect(() => {
    // Only scroll to bottom if not loading older messages
    if (!isLoadingOlderRef.current) {
      scrollToBottom();
    }
  }, [messages]);

  // Audio recording states
  const [isRecording, setIsRecording] = useState(false);
  const [recordingDuration, setRecordingDuration] = useState(0);
  const [audioBlob, setAudioBlob] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [isUploadingAudio, setIsUploadingAudio] = useState(false);
  const [uploadedAudioUrl, setUploadedAudioUrl] = useState(null);
  const [playingAudioId, setPlayingAudioId] = useState(null);
  const [audioProgressById, setAudioProgressById] = useState({});

  // Refs for audio management
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const recordingTimerRef = useRef(null);
  const audioRefs = useRef({});
  const audioBlobUrlsRef = useRef({});

  // Get token and user ID
  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
  const userId = token ? JSON.parse(atob(token.split(".")[1])).id : null;

  // Initialize API and Socket services
  const [aeCaApiService, setAeCaApiService] = useState(null);
  const [generalApiService, setGeneralApiService] = useState(null);
  const [aeCaSocketService, setAeCaSocketService] = useState(null);
  const [generalSocket, setGeneralSocket] = useState(null);
  const selectedChatRef = useRef(null);
  const searchTimeoutRef = useRef(null);

  useEffect(() => {
    selectedChatRef.current = selectedChat;
  }, [selectedChat]);

  // Initialize API services
  useEffect(() => {
    console.log("🔌 GENERAL SOCKET INIT");
    if (token) {
      setAeCaApiService(new AeCaChatApi(token));
      setGeneralApiService(new GeneralMessagingApi(token));
    }
  }, [token]);
const isActiveChat = (threadId, chatType) => {
return (
selectedChatRef.current &&
String(selectedChatRef.current.id) === String(threadId) &&
selectedChatRef.current.chatType === chatType
);
};
  // Initialize AE-CA Socket service
  useEffect(() => {
    if (!token) return;
    console.log("🔌 AE-CA SOCKET INIT");

    const socket = new AeCaChatSocket(token);
    
    socket.on('authenticated', (data) => {
      console.log('✅ AE-CA Socket authenticated:', data);
      if (data.user) {
        socket.joinUserRoom(data.user.id);
        socket.getUserStatuses();
      }
    });

    socket.on('receive_message', (data) => {
      handleIncomingMessage(data, 'receive_ae_ca_message', 'company_admin');
    });

    socket.on('message_sent', (data) => {
      handleIncomingMessage(data, 'ae_ca_message_sent', 'company_admin');
    });

    // socket.on('total_unread_count_updated', (data) => {
    //   updateUnreadCounts(data, 'company_admin');
    // });

 socket.on('total_unread_count_updated', (data) => {
if (data.chatType === 'company_admin') {
updateUnreadCounts(data, 'company_admin');
} else if (data.chatType === 'super_admin') {
updateUnreadCounts(data, 'super_admin');
}
});

    socket.on('user_statuses_list', (data) => {
      console.log('👥 User statuses received:', data);
      // Handle both response structures: data.users (from AE-CA) or data.statuses (from general)
      const statuses = data.users || data.statuses || [];
      if (Array.isArray(statuses) && statuses.length > 0) {
        const statusMap = {};
        statuses.forEach(status => {
          statusMap[status.userId] = {
            isOnline: status.isOnline || false,
            lastSeenAt: status.lastSeenAt || null,
          };
        });
        setUserOnlineStatus(prev => ({ ...prev, ...statusMap }));
      }
    });

    socket.on('error', (error) => {
      console.error('❌ AE-CA Socket error:', error);
    });

    socket.connect();
    setAeCaSocketService(socket);

    return () => {
      socket.disconnect();
    };
  }, [token]);

  // Initialize General Messaging Socket
  useEffect(() => {
    if (!token) return;

    const socket = io(`${URL}/`, {
      auth: { token },
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5,
      autoConnect: true,
      timeout: 20000,
      forceNew: false
    });

    socket.on('connect', () => {
      console.log('✅ General Socket connected');
      socket.emit('authenticate', { token });
    });

    socket.on('authenticated', (data) => {
      console.log('✅ General Socket authenticated:', data);
      if (data.user) {
        socket.emit('join_user_room', { userId: data.user.id });
        socket.emit('get_user_statuses');
      }
    });

    socket.on('receive_message', (data) => {
      handleIncomingMessage(data, 'receive_message', 'super_admin');
    });

    socket.on('message_sent', (data) => {
      handleIncomingMessage(data, 'message_sent', 'super_admin');
    });

    socket.on('user_statuses_list', (data) => {
      console.log('👥 General user statuses received:', data);
      // Handle both response structures: data.users or data.statuses
      const statuses = data.users || data.statuses || [];
      if (Array.isArray(statuses) && statuses.length > 0) {
        const statusMap = {};
        statuses.forEach(status => {
          statusMap[status.userId] = {
            isOnline: status.isOnline || false,
            lastSeenAt: status.lastSeenAt || null,
          };
        });
        setUserOnlineStatus(prev => ({ ...prev, ...statusMap }));
      }
    });

    socket.on('user_status_updated', (data) => {
      console.log('👤 User status updated:', data);
      if (data.userId) {
        setUserOnlineStatus(prev => ({
          ...prev,
          [data.userId]: {
            isOnline: data.isOnline || false,
            lastSeenAt: data.lastSeenAt || null,
          },
        }));
      }
    });

    socket.on('error', (error) => {
      console.error('❌ General Socket error:', error);
    });

    setGeneralSocket(socket);

    return () => {
      socket.disconnect();
    };
  }, [token]);

  // Join/leave thread rooms when switching chats and request user status
  useEffect(() => {
    if (!selectedChat?.id) return;

    if (selectedChat.chatType === 'company_admin' && aeCaSocketService && aeCaSocketService.getConnectionStatus()) {
      aeCaSocketService.joinChatRoom(selectedChat.id);
      console.log('📡 Joined AE-CA thread:', selectedChat.id);
      // Request user statuses when chat is opened
      if (selectedChat.other_user_id) {
        aeCaSocketService.getUserStatuses();
      }
    } else if (selectedChat.chatType === 'super_admin' && generalSocket && generalSocket.connected) {
      generalSocket.emit('join_chat_room', { threadId: selectedChat.id });
      console.log('📡 Joined General thread:', selectedChat.id);
      // Request user statuses when chat is opened
      if (selectedChat.other_user_id) {
        generalSocket.emit('get_user_statuses');
      }
    }
  }, [selectedChat?.id, selectedChat?.chatType, selectedChat?.other_user_id, aeCaSocketService, generalSocket]);

  // Handle incoming messages
  const handleIncomingMessage = (data, eventType, chatType) => {
    console.log('🔔 handleIncomingMessage called with event:', eventType, 'chatType:', chatType, 'data:', data);

    const newMsg = data.message || data;
    const threadId = data.threadId || data.thread_id;

    const isOwnMessage = newMsg.sender_id == userId;

    // Update right-side chat if it's the current one (avoid duplicates)
    if (selectedChatRef.current && String(threadId) === String(selectedChatRef.current.id) && selectedChatRef.current.chatType === chatType) {
      setMessages((prev) => {
        const isRealMessage = !newMsg.tempId || !newMsg.tempId.startsWith('temp_');

        if (!isRealMessage) {
          return prev;
        }

        const isDuplicate = prev.some(msg =>
          msg.id === newMsg.id ||
          (msg.tempId && msg.tempId === newMsg.tempId)
        );

        if (isDuplicate) {
          return prev;
        }

        const newMessages = [...prev, newMsg];
        return newMessages.slice(-50);
      });
    }

    // Update left-side thread list
    setChatList((prev) => {
      const updated = prev.map((c) => {
        if (String(c.id) === String(threadId) && c.chatType === chatType) {
          let displayMsg = newMsg.content;
          let messageIcon = null;
          if (newMsg.message_type === "image") {
            displayMsg = "";
            messageIcon = "image";
          } else if (newMsg.message_type === "system" || newMsg.message_type === "file") {
            displayMsg = "";
            // Check if it's an audio message
            const isAudioMessage = 
              newMsg.file_type?.startsWith('audio/') || 
              newMsg.mime_type?.startsWith('audio/') ||
              newMsg.file_name === "audio.webm" ||
              newMsg.file_name?.endsWith('.webm') ||
              newMsg.file_url?.includes('audio');
            
            if (isAudioMessage) {
              messageIcon = "audio";
            } else {
              messageIcon = "file";
            }
          }

          return {
            ...c,
            msg: displayMsg,
            time: formatThreadTime(newMsg.created_at),
            last_message_at: newMsg.created_at,
            message_type: newMsg.message_type,
            file_url: newMsg.file_url,
            messageIcon: messageIcon,
          };
        }
        return c;
      });

      const sorted = updated.sort((a, b) => {
        const aTime = new Date(a.last_message_at || a.created_at);
        const bTime = new Date(b.last_message_at || b.created_at);
        return bTime - aTime;
      });

      return sorted;
    });
  };

  // Update unread counts
  // const updateUnreadCounts = (data, chatType) => {
  //   setTotalUnreadCount(prev => (prev || 0) + (data.totalUnread || 0));
  //   if (data.threadCounts) {
  //     setUnreadCounts(prev => {
  //       const counts = { ...prev };
  //       data.threadCounts.forEach(item => {
  //         counts[`${chatType}_${item.threadId}`] = item.unreadCount || 0;
  //       });
  //       return counts;
  //     });
  //   }
  // };
// Update unread counts (use latest values, don't add)
// Note: Sidebar counts are handled by the global hook, this only updates local state
const updateUnreadCounts = (data, chatType) => {
  // overwrite total (correct)
  if (typeof data?.totalUnread === "number") {
    setTotalUnreadCount(data.totalUnread);
    // Note: Don't dispatch to Redux here - global hook handles sidebar counts
  }

  if (Array.isArray(data?.threadCounts)) {
    setLocalUnreadCounts(prev => {
      const counts = { ...prev };

      data.threadCounts.forEach(item => {
        // 🚫 DO NOT count unread for active chat
        if (isActiveChat(item.threadId, chatType)) {
          counts[`${chatType}_${item.threadId}`] = 0;
        } else {
          counts[`${chatType}_${item.threadId}`] = item.unreadCount || 0;
        }
      });

      return counts;
    });
  }
};
  // Format thread time
  const formatThreadTime = (dbTimestamp) => {
    try {
      const messageDate = new Date(dbTimestamp);
      if (isNaN(messageDate.getTime())) {
        return t('invalid_time');
      }

      const now = new Date();
      const timeDiff = Math.abs(now.getTime() - messageDate.getTime());

      if (timeDiff < 60000) {
        return now.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        });
      }

      return messageDate.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      });
    } catch (error) {
      return t('error');
    }
  };

  // Format message time (actual time format)
  const formatMessageTime = (dbTimestamp) => {
    try {
      const messageDate = new Date(dbTimestamp);
      if (isNaN(messageDate.getTime())) {
        return '';
      }

      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const messageDay = new Date(messageDate.getFullYear(), messageDate.getMonth(), messageDate.getDate());
      const diffDays = Math.floor((today - messageDay) / (1000 * 60 * 60 * 24));

      // If message is from today, show only time
      if (diffDays === 0) {
        return messageDate.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        });
      }
      
      // If message is from yesterday, show "Yesterday" and time
      if (diffDays === 1) {
        return `Yesterday ${messageDate.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        })}`;
      }
      
      // If message is from this week, show day name and time
      if (diffDays < 7) {
        return `${messageDate.toLocaleDateString('en-US', { weekday: 'short' })} ${messageDate.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        })}`;
      }

      // For older messages, show date and time
      return messageDate.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch (error) {
      return '';
    }
  };

  // Format last seen time
  const formatLastSeen = (lastSeenAt) => {
    if (!lastSeenAt) return 'Never';
    
    const lastSeen = new Date(lastSeenAt);
    const now = new Date();
    const diffMs = now - lastSeen;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    
    if (diffMins < 1) return 'Just now';
    if (diffMins === 1) return '1 min ago';
    if (diffMins < 60) return `${diffMins} mins ago`;
    if (diffHours === 1) return '1 hr ago';
    if (diffHours < 24) return `${diffHours} hrs ago`;
    if (diffDays === 1) return '1 day ago';
    if (diffDays < 7) return `${diffDays} days ago`;
    
    return lastSeen.toLocaleDateString();
  };

  // Get online status indicator
  const getOnlineStatusIndicator = (userId) => {
    const status = userOnlineStatus[userId];
    if (!status) return null;
    
    if (status.isOnline) {
      return (
        <Tooltip title={t('online') || 'Online'}>
          <FiberManualRecord 
            sx={{ 
              fontSize: 12, 
              color: '#4CAF50',
              position: 'absolute',
              bottom: 0,
              right: 0,
              backgroundColor: 'white',
              borderRadius: '50%',
            }} 
          />
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title={`${t('last_seen') || 'Last seen'} ${formatLastSeen(status.lastSeenAt)}`}>
          <FiberManualRecord 
            sx={{ 
              fontSize: 12, 
              color: '#9E9E9E',
              position: 'absolute',
              bottom: 0,
              right: 0,
              backgroundColor: 'white',
              borderRadius: '50%',
            }} 
          />
        </Tooltip>
      );
    }
  };

  // Get online status text with role
  const getOnlineStatusText = (userId, chatType) => {
    const status = userOnlineStatus[userId];
    if (!status) return null;

    const roleName = chatType === 'super_admin' 
      ? (t('Super Admin') || 'Super Admin')
      : (t('Company Admin') || 'Company Admin');

    if (status.isOnline) {
      return `${roleName} is online`;
    } else {
      return ``;
    }
  };

  // Image upload function
  const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append("image", file);

    const response = await fetch(`${BASE_URL}/upload/image`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });

    const result = await response.json();

    if (!result.error && result.data?.url) {
      return result.data.url;
    } else {
      throw new Error(result.message || "Image upload failed");
    }
  };


const navigate = useNavigate();
const fromDashboard = location.state?.fromDashboard || false;
  // File upload function
  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("pdf", file);

    const response = await fetch(`${BASE_URL}/upload/pdf`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });

    const result = await response.json();

    if (!result.error && result.data?.url) {
      return result.data.url;
    } else if (!result.error && result.url) {
      return result.url;
    } else {
      throw new Error(result.message || "File upload failed");
    }
  };

  // Audio upload function
  const uploadAudio = async (audioBlob) => {
    const formData = new FormData();
    formData.append("audio", audioBlob, "audio.webm");
    
    const response = await fetch(`${BASE_URL}/upload/audio`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });
    
    const result = await response.json();
    
    if (!result.error && result.data?.url) {
      return result.data.url;
    } else if (!result.error && result.url) {
      return result.url;
    } else {
      throw new Error(result.message || "Audio upload failed");
    }
  };

  // Start audio recording
  const startRecording = async () => {
    try {
      // Request microphone access
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];

      // Collect audio chunks
      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      // Handle recording stop
      mediaRecorder.onstop = async () => {
        // Create blob from chunks
        const audioBlob = new Blob(audioChunksRef.current, { type: "audio/webm" });
        const url = window.URL.createObjectURL(audioBlob);
        setAudioBlob(audioBlob);
        setAudioUrl(url);
        
        // Auto-upload audio
        setIsUploadingAudio(true);
        try {
          const audioFileUrl = await uploadAudio(audioBlob);
          setUploadedAudioUrl(audioFileUrl);
          console.log("✅ Audio uploaded successfully:", audioFileUrl);
        } catch (error) {
          console.error("❌ Audio upload failed:", error);
          toast.error(t("Audio upload failed. Please try again."));
        } finally {
          setIsUploadingAudio(false);
        }
      };

      // Start recording
      mediaRecorder.start();
      setIsRecording(true);
      setRecordingDuration(0);

      // Start timer
      recordingTimerRef.current = setInterval(() => {
        setRecordingDuration((prev) => prev + 1);
      }, 1000);
    } catch (error) {
      console.error("❌ Error starting recording:", error);
      toast.error(t("Microphone access denied. Please allow microphone access and try again."));
    }
  };

  // Stop audio recording
  const stopRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
      mediaRecorderRef.current.stop();
      mediaRecorderRef.current.stream.getTracks().forEach((track) => track.stop());
      setIsRecording(false);
      
      if (recordingTimerRef.current) {
        clearInterval(recordingTimerRef.current);
        recordingTimerRef.current = null;
      }
    }
  };

  // Format duration helper
  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Helper function to construct full URL from relative path
  const getFileUrl = (fileUrl) => {
    if (!fileUrl) return '';
    
    // If already full URL, return as is
    if (fileUrl.startsWith('http://') || fileUrl.startsWith('https://')) {
      return fileUrl;
    }
    
    // If relative path, prepend base URL
    return `${BASE_URL}${fileUrl.startsWith('/') ? fileUrl : '/' + fileUrl}`;
  };

  // Toggle audio playback
  const toggleAudioPlayback = async (messageId, audioUrl) => {
    if (!audioUrl || audioUrl.trim() === '') {
      console.error("❌ Invalid audio URL:", audioUrl);
      return;
    }

    // If already playing this audio, pause it
    if (playingAudioId === messageId) {
      const audio = audioRefs.current[messageId];
      if (audio) {
        audio.pause();
        setPlayingAudioId(null);
        return;
      }
    }

    try {
      // Construct full URL if needed
      const fullAudioUrl = getFileUrl(audioUrl);

      // Fetch audio with authentication (handles CORS)
      const response = await fetch(fullAudioUrl, {
        method: "GET",
        headers: { 
          Authorization: `Bearer ${token}`,
          'Accept': 'audio/webm, audio/*'
        },
        mode: 'cors'
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Store blob URL for cleanup
      audioBlobUrlsRef.current[messageId] = blobUrl;

      // Create audio element
      const audio = new Audio(blobUrl);
      audioRefs.current[messageId] = audio;

      // Load metadata (duration)
      audio.onloadedmetadata = () => {
        const duration = isFinite(audio.duration) ? Math.floor(audio.duration) : 0;
        setAudioProgressById(prev => ({
          ...prev,
          [messageId]: { current: 0, duration }
        }));
      };

      // Track progress
      audio.ontimeupdate = () => {
        setAudioProgressById(prev => ({
          ...prev,
          [messageId]: {
            current: Math.floor(audio.currentTime || 0),
            duration: Math.floor(audio.duration || prev[messageId]?.duration || 0)
          }
        }));
      };

      // Handle end
      audio.onended = () => {
        setPlayingAudioId(null);
        // Cleanup blob URL
        if (audioBlobUrlsRef.current[messageId]) {
          window.URL.revokeObjectURL(audioBlobUrlsRef.current[messageId]);
          delete audioBlobUrlsRef.current[messageId];
        }
        audioRefs.current[messageId] = null;
        setAudioProgressById(prev => ({ 
          ...prev, 
          [messageId]: { current: 0, duration: prev[messageId]?.duration || 0 } 
        }));
      };

      // Handle errors
      audio.onerror = (e) => {
        setPlayingAudioId(null);
        console.error("❌ Error playing audio:", e);
        toast.error(t("Error playing audio. The audio file may be corrupted or unsupported."));
        // Cleanup on error
        if (audioBlobUrlsRef.current[messageId]) {
          window.URL.revokeObjectURL(audioBlobUrlsRef.current[messageId]);
          delete audioBlobUrlsRef.current[messageId];
        }
        audioRefs.current[messageId] = null;
      };

      // Play audio
      await audio.play();
      setPlayingAudioId(messageId);
      
    } catch (error) {
      console.error("❌ Error fetching/playing audio:", error);
      toast.error(t("Failed to load audio file. Please check the URL or try again."));
    }
  };

  // Cleanup audio blob URLs
  useEffect(() => {
    return () => {
      // Cleanup audio blob URLs
      Object.values(audioBlobUrlsRef.current).forEach(url => {
        if (url && url.startsWith('blob:')) {
          window.URL.revokeObjectURL(url);
        }
      });
      // Cleanup audio elements
      Object.values(audioRefs.current).forEach(audio => {
        if (audio) {
          audio.pause();
          audio.src = '';
        }
      });
      // Cleanup recording
      if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
        mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop());
      }
      if (recordingTimerRef.current) {
        clearInterval(recordingTimerRef.current);
      }
      if (audioUrl) {
        window.URL.revokeObjectURL(audioUrl);
      }
    };
  }, []);

  // Handle file selection
  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      console.log("No file selected");
      return;
    }
    console.log("File selected:", file.name, file.type, file.size);

    const isImage = file.type.startsWith('image/');
    const isDocument = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'text/plain',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ].includes(file.type);

    if (!isImage && !isDocument) {
      toast.error(t("Please select an image, PDF, or Word document"));
      return;
    }

    const maxSize = isImage ? 5 * 1024 * 1024 : 10 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error(t(isImage ? "Image size should be less than 5MB" : "File size should be less than 10MB"));
      return;
    }

    if (isImage) {
      setSelectedImageFile(file);
      // Create immediate preview using object URL (use window.URL to avoid conflict with imported URL)
      const objectUrl = window.URL.createObjectURL(file);
      setImagePreview(objectUrl);

      // Also read as data URL for backup
      const reader = new FileReader();
      reader.onload = (e) => {
        // Revoke object URL and use data URL instead
        window.URL.revokeObjectURL(objectUrl);
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);

      setIsUploadingImage(true);
      try {
        const imageUrl = await uploadImage(file);
        setUploadedImageUrl(imageUrl);
      } catch (error) {
        console.error("❌ Image upload failed:", error);
        toast.error(t("Image upload failed. Please try again."));
        setImagePreview(null);
        setSelectedImageFile(null);
        window.URL.revokeObjectURL(objectUrl);
      } finally {
        setIsUploadingImage(false);
        event.target.value = '';
      }
    } else {
      setSelectedFile(file);
      setIsUploadingFile(true);
      try {
        const fileUrl = await uploadFile(file);
        setUploadedFileUrl(fileUrl);
      } catch (error) {
        console.error("❌ File upload failed:", error);
        toast.error(t("File upload failed. Please try again."));
        setSelectedFile(null);
      } finally {
        setIsUploadingFile(false);
        event.target.value = '';
      }
    }
  };

  const clearUploadedImage = () => {
    // Revoke object URL if it's an object URL (use window.URL to avoid conflict with imported URL)
    if (imagePreview && imagePreview.startsWith('blob:')) {
      window.URL.revokeObjectURL(imagePreview);
    }
    setUploadedImageUrl(null);
    setImagePreview(null);
    setSelectedImageFile(null);
  };

  const clearUploadedFile = () => {
    setUploadedFileUrl(null);
    setSelectedFile(null);
  };

  const clearUploadedAudio = () => {
    if (audioUrl) {
      window.URL.revokeObjectURL(audioUrl);
    }
    setUploadedAudioUrl(null);
    setAudioBlob(null);
    setAudioUrl(null);
    setRecordingDuration(0);
  };

  // Download file function
  const downloadFile = async (fileUrl, fileName) => {
    try {
      // Construct full URL if needed
      const fullFileUrl = getFileUrl(fileUrl);
      
      const response = await fetch(fullFileUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) {
        throw new Error('Download failed');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName || 'document';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
      toast.error(t('Download failed. Please try again.'));
    }
  };

  // Role badge helper functions
  const getRoleBadgeLabel = (role, chatType) => {
    // If role is provided, use it; otherwise infer from chatType
    const effectiveRole = role || chatType;
   switch (effectiveRole) {
case "account_executive":
return t("chat.roles.account_executive");


case "company_admin":
return t("chat.roles.company_admin");


case "worker":
return t("chat.roles.worker");


case "super_admin":
case "superadmin":
return t("chat.roles.super_admin");


default:
return t("chat.roles.user");
}
  };


  const getRoleBadgeColor = (role, chatType) => {
    const effectiveRole = role || chatType;
    switch(effectiveRole) {
      case 'account_executive': return { bg: '#E3F2FD', text: '#1565C0' }; // Light blue
      case 'company_admin': return { bg: '#FFF3E0', text: '#E65100' };     // Light orange
      case 'worker': return { bg: '#E8F5E9', text: '#2E7D32' };            // Light green
      case 'super_admin': return { bg: '#FCE4EC', text: '#C2185B' };       // Light pink
      case 'superadmin': return { bg: '#FCE4EC', text: '#C2185B' };        // Light pink
      default: return { bg: '#F5F5F5', text: '#757575' };
    }
  };

  // Helper function to process thread data
  const processThreadData = (thread, chatType) => {
    const threadUserId = thread.other_user_id 
      ? (typeof thread.other_user_id === 'string' ? parseInt(thread.other_user_id, 10) : thread.other_user_id) 
      : null;
    
    return {
      id: thread.id,
      name: thread.other_user_name,
      msg: thread.last_message_content || t('new_conversation_started'),
      time: formatThreadTime(thread.last_message_at || thread.created_at),
      icon: thread.other_user_avatar || "",
      other_user_id: threadUserId,
      other_user_email: thread.other_user_email || thread.email || "",
      other_user_role: thread.other_user_role || chatType,
      created_at: thread.created_at,
      last_message_at: thread.last_message_at,
      unread_count: thread.unread_count || 0,
      chatType: chatType,
    };
  };

  // Fetch threads from both systems
  const fetchThreads = async (page = 1, append = false) => {
    if (!aeCaApiService || !generalApiService) return;
    
    if (page === 1) {
      setIsLoadingThreads(true);
    }
    
    try {
      // Fetch from both systems in parallel
      const [aeCaResult, generalResult] = await Promise.all([
        aeCaApiService.getThreads(page, THREADS_PER_PAGE).catch(err => ({ error: true, data: { threads: [], pagination: {} } })),
        generalApiService.getThreads(page, THREADS_PER_PAGE).catch(err => ({ error: true, data: { threads: [], pagination: {} } }))
      ]);

      const allThreads = [];
      let totalCount = 0;
      let hasMore = false;

      // Process AE-CA threads (Company Admin)
      if (!aeCaResult.error && Array.isArray(aeCaResult.data?.threads)) {
        const threads = aeCaResult.data.threads.map((thread) => processThreadData(thread, 'company_admin'));
        allThreads.push(...threads);
        
        // Check pagination
        const pagination = aeCaResult.data.pagination;
        if (pagination) {
          totalCount += pagination.total_count || pagination.total || 0;
          hasMore = hasMore || pagination.has_next_page || (pagination.page < pagination.pages);
        }
      }

      // Process General threads (Super Admin)
      if (!generalResult.error && Array.isArray(generalResult.data?.threads)) {
        const threads = generalResult.data.threads.map((thread) => processThreadData(thread, 'super_admin'));
        allThreads.push(...threads);
        
        // Check pagination
        const pagination = generalResult.data.pagination;
        if (pagination) {
          totalCount += pagination.total_count || pagination.total || 0;
          hasMore = hasMore || pagination.has_next_page || (pagination.page < pagination.pages);
        }
      }

      // Sort all threads by last message time
      const sortedThreads = allThreads.sort((a, b) => {
        const aTime = new Date(a.last_message_at || a.created_at);
        const bTime = new Date(b.last_message_at || b.created_at);
        return bTime - aTime;
      });

      setTimeout(() => {
        if (append) {
          setChatList(prev => {
            // Filter out duplicates
            const existingIds = new Set(prev.map(t => `${t.chatType}_${t.id}`));
            const newThreads = sortedThreads.filter(t => !existingIds.has(`${t.chatType}_${t.id}`));
            return [...prev, ...newThreads];
          });
        } else {
          setChatList(sortedThreads);
        }
        setShowThreads(true);
        setTotalThreads(totalCount);
        setHasMoreThreads(hasMore || allThreads.length >= THREADS_PER_PAGE);
        setThreadsPage(page);
      }, 100);
    } catch (err) {
      console.error("❌ Error fetching threads:", err);
      toast.error(t("Failed to load conversations"));
    } finally {
      setIsLoadingThreads(false);
      setIsLoadingMoreThreads(false);
    }
  };

  // Load more threads
  const loadMoreThreads = async () => {
    if (isLoadingMoreThreads || !hasMoreThreads) return;
    
    setIsLoadingMoreThreads(true);
    await fetchThreads(threadsPage + 1, true);
  };

  // Fetch messages with pagination support
  const fetchMessages = async (threadId, chatType, page = 1, append = false) => {
    if (page === 1) {
      setIsLoadingMessages(true);
      setCurrentPage(1);
      setHasMoreMessages(true);
    }
    
    try {
      let result;
      if (chatType === 'company_admin' && aeCaApiService) {
        result = await aeCaApiService.getThreadMessages(threadId, page, MESSAGES_PER_PAGE);
        if (!result.error && result.data?.messages) {
          const newMessages = result.data.messages;
          const pagination = result.data.pagination;
          
          if (append) {
            // Prepend older messages to the beginning
            setMessages(prev => [...newMessages, ...prev]);
          } else {
            setMessages(newMessages);
          }
          
          // Update pagination state
          if (pagination) {
            const total = pagination.total_count || pagination.total || 0;
            const hasMore = pagination.has_next_page !== undefined 
              ? pagination.has_next_page 
              : (page * MESSAGES_PER_PAGE < total);
            setTotalMessages(total);
            setHasMoreMessages(hasMore);
          } else {
            setHasMoreMessages(newMessages.length >= MESSAGES_PER_PAGE);
          }
          
          setCurrentPage(page);
          
          // Mark as read only on first page load
          if (page === 1) {
            // Get the unread count before marking as read
            const currentChat = chatList.find(c => c.id === threadId && c.chatType === chatType);
            const unreadToMark = currentChat?.unread_count || 0;
            
            await aeCaApiService.markAllAsRead(threadId);
            if (aeCaSocketService) {
              aeCaSocketService.markAsRead(threadId);
            }
            
            // Update sidebar count in Redux
            if (unreadToMark > 0) {
              dispatch(updateCompanyAdminCount({ type: 'set', count: Math.max(0, (chatList.filter(c => c.chatType === 'company_admin' && c.id !== threadId).reduce((sum, c) => sum + (c.unread_count || 0), 0))) }));
            }
            
            // Update local chat list to show 0 unread
            setChatList(prev => prev.map(c => 
              c.id === threadId && c.chatType === chatType 
                ? { ...c, unread_count: 0 } 
                : c
            ));
          }
        }
      } else if (chatType === 'super_admin' && generalApiService) {
        result = await generalApiService.getThreadMessages(threadId, page, MESSAGES_PER_PAGE);
        if (!result.error && result.data?.messages) {
          const newMessages = result.data.messages;
          const pagination = result.data.pagination;
          
          if (append) {
            // Prepend older messages to the beginning
            setMessages(prev => [...newMessages, ...prev]);
          } else {
            setMessages(newMessages);
          }
          
          // Update pagination state
          if (pagination) {
            const total = pagination.total_count || pagination.total || 0;
            const hasMore = pagination.has_next_page !== undefined 
              ? pagination.has_next_page 
              : (page * MESSAGES_PER_PAGE < total);
            setTotalMessages(total);
            setHasMoreMessages(hasMore);
          } else {
            setHasMoreMessages(newMessages.length >= MESSAGES_PER_PAGE);
          }
          
          setCurrentPage(page);
          
          // Mark as read only on first page load
          if (page === 1) {
            // Get the unread count before marking as read
            const currentChat = chatList.find(c => c.id === threadId && c.chatType === chatType);
            const unreadToMark = currentChat?.unread_count || 0;
            
            await generalApiService.markAllAsRead(threadId);
            if (generalSocket && generalSocket.connected) {
              generalSocket.emit('mark_read', { threadId });
            }
            
            // Update sidebar count in Redux
            if (unreadToMark > 0) {
              dispatch(updateSuperAdminCount({ type: 'set', count: Math.max(0, (chatList.filter(c => c.chatType === 'super_admin' && c.id !== threadId).reduce((sum, c) => sum + (c.unread_count || 0), 0))) }));
            }
            
            // Update local chat list to show 0 unread
            setChatList(prev => prev.map(c => 
              c.id === threadId && c.chatType === chatType 
                ? { ...c, unread_count: 0 } 
                : c
            ));
          }
        }
      }
    } catch (err) {
      console.error("❌ Error fetching messages:", err);
      toast.error(t("Failed to load messages"));
    } finally {
      setIsLoadingMessages(false);
      setIsLoadingMoreMessages(false);
      isLoadingOlderRef.current = false;
    }
  };

  // Load more (older) messages
  const loadMoreMessages = async () => {
    if (isLoadingMoreMessages || !hasMoreMessages || !selectedChat) return;
    
    isLoadingOlderRef.current = true;
    setIsLoadingMoreMessages(true);
    await fetchMessages(selectedChat.id, selectedChat.chatType, currentPage + 1, true);
  };

  // Mark all messages as read across all threads
  const markAllMessagesAsRead = async () => {
    try {
      // Call both APIs to mark all as read
      const promises = [];
      
      if (aeCaApiService) {
        promises.push(
          fetch(`${BASE_URL}/ae-ca-chat/messages/mark-all-read`, {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }).catch(err => console.error("AE-CA mark all read error:", err))
        );
      }
      
      if (generalApiService) {
        promises.push(
          fetch(`${BASE_URL}/general-messaging/messages/mark-all-read`, {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }).catch(err => console.error("General mark all read error:", err))
        );
      }
      
      await Promise.all(promises);
      
      // Emit socket events
      if (aeCaSocketService) {
        aeCaSocketService.emit("mark_all_ae_ca_messages_read");
      }
      if (generalSocket && generalSocket.connected) {
        generalSocket.emit("mark_all_messages_read");
      }
      
      // Update local state
      setTotalUnreadCount(0);
      setLocalUnreadCounts({});
      setChatList(prev => prev.map(chat => ({ ...chat, unread_count: 0 })));
      
      // Clear Redux counts for sidebar
      dispatch(clearAllCounts());
      dispatch(updateSuperAdminCount({ type: 'set', count: 0 }));
      dispatch(updateCompanyAdminCount({ type: 'set', count: 0 }));
      
      toast.success(t("All messages marked as read"));
    } catch (err) {
      console.error("❌ Error marking all as read:", err);
      toast.error(t("Failed to mark all as read"));
    }
  };

  // Click chat
  // const handleChatClick = (chat) => {
  //   setSelectedChat(chat);
  //   fetchMessages(chat.id, chat.chatType);
  //   // Request user status when chat is opened
  //   if (chat.other_user_id) {
  //     if (chat.chatType === 'company_admin' && aeCaSocketService && aeCaSocketService.getConnectionStatus()) {
  //       aeCaSocketService.getUserStatuses();
  //     } else if (chat.chatType === 'super_admin' && generalSocket && generalSocket.connected) {
  //       generalSocket.emit('get_user_statuses');
  //     }
  //   }
  // };

  const handleChatClick = (chat) => {
  // 1) Clear unread locally for this thread (so UI updates instantly)
  const key = `${chat.chatType}_${chat.id}`;
  const previousUnread = localUnreadCounts[key] ?? chat.unread_count ?? 0;

  setLocalUnreadCounts(prev => ({ ...prev, [key]: 0 }));

  setChatList(prev =>
    prev.map(c =>
      String(c.id) === String(chat.id) && c.chatType === chat.chatType
        ? { ...c, unread_count: 0 }
        : c
    )
  );

  setTotalUnreadCount(prev => Math.max(0, (prev || 0) - (previousUnread || 0)));
  
  // Note: Don't dispatch to Redux sidebar counts here - the socket event 'messages_read' 
  // will trigger a refetch which updates the sidebar counts accurately
  
  // 2) Normal flow
  setSelectedChat(chat);
  fetchMessages(chat.id, chat.chatType);

  // Request user status when chat is opened (your existing code)
  if (chat.other_user_id) {
    if (chat.chatType === 'company_admin' && aeCaSocketService && aeCaSocketService.getConnectionStatus()) {
      aeCaSocketService.getUserStatuses();
    } else if (chat.chatType === 'super_admin' && generalSocket && generalSocket.connected) {
      generalSocket.emit('get_user_statuses');
    }
  }
};

  // Send message
  const handleSendMessage = async () => {
    if ((!newMessage.trim() && !uploadedImageUrl && !uploadedFileUrl && !uploadedAudioUrl) || !selectedChat || isSendingMessage) return;

    setIsSendingMessage(true);

    try {
      let messageContent = newMessage.trim() || "File shared";
      let messageType = "text";
      let fileUrl = null;
      let fileName = null;
      let fileType = null;

      // Determine message type and file details
      if (uploadedAudioUrl) {
        messageType = "audio";
        fileUrl = uploadedAudioUrl;
        fileName = "audio.webm";
        fileType = "audio/webm";
      } else if (uploadedFileUrl) {
        messageType = "system";
        fileUrl = uploadedFileUrl;
        fileName = selectedFile?.name;
        fileType = selectedFile?.type;
      } else if (uploadedImageUrl) {
        messageType = "image";
        fileUrl = uploadedImageUrl;
      }

      const chatType = selectedChat.chatType;

      if (chatType === 'company_admin') {
        if (aeCaSocketService && aeCaSocketService.getConnectionStatus()) {
          const tempId = `temp_${Date.now()}`;
          aeCaSocketService.sendMessage(
            selectedChat.id,
            messageContent,
            messageType,
            fileUrl,
            fileName,
            selectedFile?.size,
            fileType,
            tempId
          );
          setNewMessage("");
          clearUploadedImage();
          clearUploadedFile();
          clearUploadedAudio();
        } else if (aeCaApiService) {
          const result = await aeCaApiService.sendMessage(
            selectedChat.id,
            messageContent,
            messageType,
            fileUrl,
            fileName,
            selectedFile?.size,
            fileType
          );
          handleMessageSent(result);
        }
      } else if (chatType === 'super_admin') {
        if (generalSocket && generalSocket.connected) {
          generalSocket.emit('send_message', {
            threadId: selectedChat.id,
            content: messageContent,
            messageType: messageType,
            fileUrl: fileUrl,
            fileName: fileName,
            fileSize: selectedFile?.size,
            mimeType: fileType,
          });
          setNewMessage("");
          clearUploadedImage();
          clearUploadedFile();
          clearUploadedAudio();
        } else if (generalApiService) {
          const result = await generalApiService.sendMessage(
            selectedChat.id,
            messageContent,
            messageType,
            fileUrl,
            fileName,
            selectedFile?.size,
            fileType
          );
          handleMessageSent(result);
        }
      }
    } catch (err) {
      console.error("Error sending message:", err);
      toast.error(t("Failed to send message"));
    } finally {
      setIsSendingMessage(false);
    }
  };

  // Handle message sent response
  const handleMessageSent = (result) => {
    if (!result.error && result.data?.message) {
      setMessages((prev) => {
        const newMessages = [...prev, result.data.message];
        return newMessages.slice(-50);
      });

      setChatList((prev) =>
        prev.map((c) => {
          if (c.id === selectedChat.id) {
            let displayMsg = result.data.message.content;
            if (result.data.message.message_type === "image") {
              displayMsg = result.data.message.content && result.data.message.content !== "File shared"
                ? `${result.data.message.content} 📷`
                : "📷 Image";
            } else if (result.data.message.message_type === "audio") {
              displayMsg = result.data.message.content && result.data.message.content !== "File shared"
                ? `${result.data.message.content} 🎵`
                : "🎵 Audio";
            } else if (result.data.message.message_type === "system" || result.data.message.message_type === "file") {
              displayMsg = result.data.message.content && result.data.message.content !== "File shared"
                ? `${result.data.message.content} 📄`
                : "📄 Document";
            }

            return {
              ...c,
              msg: displayMsg,
              time: formatThreadTime(result.data.message.created_at),
              last_message_at: result.data.message.created_at,
              message_type: result.data.message.message_type,
              file_url: result.data.message.file_url,
            };
          }
          return c;
        })
      );
    }
    setNewMessage("");
    clearUploadedImage();
    clearUploadedFile();
    clearUploadedAudio();
  };

  // Handle Add button click - show dialog
  const handleAddClick = () => {
    setShowUserDialog(true);
    setSelectedRole(null);
    setUserList([]);
    setUserSearchTerm("");
  };

  const handleDialogClose = () => {
    setShowUserDialog(false);
    setSelectedRole(null);
    setUserList([]);
    setUserSearchTerm("");
    setSelectedUsers([]);
    setBulkMessageText("");
  };

  const handleSelectRole = (role) => {
    setSelectedRole(role);
    setSelectedChatType(role === 'super_admin' ? 'super_admin' : 'company_admin');
    setUserSearchTerm("");
    setSelectedUsers([]);
    setBulkMessageText("");
    fetchUsers(role === 'super_admin' ? 'super_admin' : 'company_admin', '');
  };

  // Fetch users based on selected chat type
  const fetchUsers = async (chatType, searchQuery = '') => {
    setIsLoadingUsers(true);
    try {
      let result;
      if (chatType === 'company_admin' && aeCaApiService) {
        result = await aeCaApiService.getEligibleUsers(searchQuery, 1, 500);
      } else if (chatType === 'super_admin' && generalApiService) {
        // Use 'super_admin' (with underscore) as per endpoint specification
        result = await generalApiService.getEligibleUsers('super_admin', searchQuery, 1, 500);
      }

      console.log("📋 Fetch users result:", { chatType, result });

      if (result && !result.error) {
        // Handle different response structures
        const users = result.data?.users || result.data?.super_admins || result.data || [];
        if (Array.isArray(users)) {
          setUserList(users);
        } else {
          console.error("❌ Invalid users format:", users);
          setUserList([]);
          toast.error(t("Invalid response format"));
        }
      } else if (result && result.error) {
        console.error("❌ API error:", result.message || result.error);
        setUserList([]);
        toast.error(result.message || t("Failed to load users"));
      } else {
        console.warn("⚠️ No result returned");
        setUserList([]);
      }
    } catch (err) {
      console.error("❌ Error fetching users:", err);
      setUserList([]);
      toast.error(t("Failed to load users"));
    } finally {
      setIsLoadingUsers(false);
    }
  };

  // Start new chat
  const startNewChat = async (user) => {
    if (!selectedChatType) return;
    
    const tempId = `temp-${user.id}-${Date.now()}`;
    const currentTime = formatThreadTime(new Date().toISOString());
    
    // Construct user name from available fields
    const userName = user.name || 
                    `${user.first_name || ''} ${user.last_name || ''}`.trim() ||
                    user.email ||
                    'Unknown User';
    const userAvatar = user.profile_image 
                      ? (user.profile_image.startsWith('http://') || user.profile_image.startsWith('https://'))
                        ? user.profile_image
                        : `${BASE_URL}${user.profile_image.startsWith('/') ? user.profile_image : '/' + user.profile_image}`
                      : "";

    // Ensure user.id is a number for consistent comparison
    const userIdNum = typeof user.id === 'string' ? parseInt(user.id, 10) : user.id;
    
    const optimisticThread = {
      id: tempId,
      name: userName,
      msg: t('new_conversation_started'),
      time: currentTime,
      icon: userAvatar,
      other_user_id: userIdNum,
      created_at: new Date().toISOString(),
      last_message_at: new Date().toISOString(),
      chatType: selectedChatType,
    };

    // Check if thread already exists (use String comparison for safety)
    const existingThread = chatList.find((c) => String(c.other_user_id) === String(userIdNum) && c.chatType === selectedChatType);
    if (existingThread) {
      setShowUserList(false);
      // Move thread to top of list
      setChatList(prev => {
        const filtered = prev.filter(c => c.id !== existingThread.id);
        return [existingThread, ...filtered];
      });
      setSelectedChat(existingThread);
      fetchMessages(existingThread.id, existingThread.chatType);
      return;
    }

    setChatList((prev) => [optimisticThread, ...prev]);
    setShowUserList(false);
    setSelectedChat(optimisticThread);
    setMessages([]);

    try {
      let result;
      if (selectedChatType === 'company_admin' && aeCaApiService) {
        result = await aeCaApiService.createOrGetThread(user.id, 'company_admin');
      } else if (selectedChatType === 'super_admin' && generalApiService) {
        // Use 'superadmin' (without underscore) as per backend changes
        result = await generalApiService.createOrGetThread(user.id, 'superadmin');
      }

      if (result && !result.error && result.data?.thread) {
        const thread = result.data.thread;
        // Use thread.other_user_name if available, otherwise construct from user object
        const confirmedUserName = thread.other_user_name || 
                        user.name || 
                        `${user.first_name || ''} ${user.last_name || ''}`.trim() ||
                        user.email ||
                        'Unknown User';
        // Use thread.other_user_avatar if available, otherwise construct from user object
        const confirmedUserAvatar = thread.other_user_avatar || 
                          (user.profile_image 
                            ? (user.profile_image.startsWith('http://') || user.profile_image.startsWith('https://'))
                              ? user.profile_image
                              : `${BASE_URL}${user.profile_image.startsWith('/') ? user.profile_image : '/' + user.profile_image}`
                            : "");
        
        // Ensure other_user_id is a number for consistent storage
        const threadUserId = thread.other_user_id 
          ? (typeof thread.other_user_id === 'string' ? parseInt(thread.other_user_id, 10) : thread.other_user_id) 
          : userIdNum;
        
        const confirmedThread = {
          id: thread.id,
          name: confirmedUserName,
          msg: t('new_conversation_started'),
          time: formatThreadTime(thread.created_at || new Date().toISOString()),
          icon: confirmedUserAvatar,
          other_user_id: threadUserId,
          created_at: thread.created_at || new Date().toISOString(),
          last_message_at: thread.created_at || new Date().toISOString(),
          chatType: selectedChatType,
        };

        setChatList((prev) => {
          const withoutTemp = prev.filter((c) => c.id !== tempId);
          const existsById = withoutTemp.some((c) => c.id === confirmedThread.id);
          const existsByUserId = withoutTemp.some((c) => String(c.other_user_id) === String(confirmedThread.other_user_id) && c.chatType === confirmedThread.chatType);

          if (existsById) {
            // Move to top
            const filtered = withoutTemp.filter((c) => c.id !== confirmedThread.id);
            return [confirmedThread, ...filtered];
          } else if (existsByUserId) {
            // Update existing and move to top
            const filtered = withoutTemp.filter((c) => !(String(c.other_user_id) === String(confirmedThread.other_user_id) && c.chatType === confirmedThread.chatType));
            return [confirmedThread, ...filtered];
          } else {
            return [confirmedThread, ...withoutTemp];
          }
        });

        setSelectedChat(confirmedThread);
        fetchMessages(confirmedThread.id, confirmedThread.chatType);
      } else {
        setChatList((prev) => prev.filter((t) => t.id !== tempId));
        toast.error(t("Failed to create conversation"));
      }
    } catch (err) {
      setChatList((prev) => prev.filter((t) => t.id !== tempId));
      console.error("❌ Error starting chat:", err);
      toast.error(t("Failed to start conversation"));
    }
  };

  // Toggle user selection for Company Admin multi-select
  const toggleUserSelection = (userId) => {
    setSelectedUsers((prev) => {
      if (prev.includes(userId)) {
        return prev.filter((id) => id !== userId);
      } else {
        return [...prev, userId];
      }
    });
  };

  // Select/Deselect all visible users
  const handleSelectAll = (checked) => {
    if (checked) {
      // Select all visible (filtered) users
      const filteredUsers = userList.filter((user) => {
        const name = user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim();
        const email = user.email || '';
        const searchLower = userSearchTerm.toLowerCase();
        return name.toLowerCase().includes(searchLower) || email.toLowerCase().includes(searchLower);
      });
      const allUserIds = filteredUsers.map((user) => user.id);
      setSelectedUsers(allUserIds);
    } else {
      setSelectedUsers([]);
    }
  };

  // Clear all selections
  const handleClearSelection = () => {
    setSelectedUsers([]);
    setBulkMessageText("");
  };

  // Send message to multiple selected users
  const handleBulkSendMessage = async () => {
    if (!bulkMessageText.trim() || selectedUsers.length === 0 || isSendingBulkMessage) return;

    setIsSendingBulkMessage(true);
    let successCount = 0;
    let failCount = 0;

    try {
      // Get selected user objects
      const selectedUserObjects = userList.filter((user) => selectedUsers.includes(user.id));

      // Loop through each selected user and send message
      for (const user of selectedUserObjects) {
        try {
          // Create or get existing thread
          const threadResult = await aeCaApiService.createOrGetThread(user.id, 'company_admin');
          
          if (threadResult && !threadResult.error && threadResult.data?.thread) {
            const threadId = threadResult.data.thread.id;
            
            // Send message to this thread
            const messageResult = await aeCaApiService.sendMessage(
              threadId,
              bulkMessageText.trim(),
              'text',
              null,
              null,
              null,
              null
            );

            if (messageResult && !messageResult.error) {
              successCount++;
            } else {
              failCount++;
              console.error(`❌ Failed to send message to ${user.name || user.email}:`, messageResult);
            }
          } else {
            failCount++;
            console.error(`❌ Failed to create/get thread for ${user.name || user.email}:`, threadResult);
          }
        } catch (err) {
          failCount++;
          console.error(`❌ Error sending message to ${user.name || user.email}:`, err);
        }
      }

      // Show summary toast
      if (successCount > 0) {
        toast.success(t(`Message sent to ${successCount} user${successCount > 1 ? 's' : ''}`));
      }
      if (failCount > 0) {
        toast.error(t(`Failed to send to ${failCount} user${failCount > 1 ? 's' : ''}`));
      }

      // Clear selections and close dialog
      handleClearSelection();
      handleDialogClose();
      
      // Refresh thread list
      fetchThreads();
    } catch (err) {
      console.error("❌ Error in bulk send:", err);
      toast.error(t("Failed to send messages"));
    } finally {
      setIsSendingBulkMessage(false);
    }
  };

  // Load initial data
useEffect(() => {
    if (token && aeCaApiService && generalApiService) {
      fetchThreads();
      // Load unread counts from both systems
      Promise.all([
        aeCaApiService.getDetailedUnreadCounts().catch(() => ({ error: true, data: {} })),
        generalApiService.getUnreadCount().catch(() => ({ error: true, data: {} }))
      ]).then(([aeCaResult, generalResult]) => {
        let total = 0;
        let companyAdminTotal = 0;
        let superAdminTotal = 0;
        const counts = {};
        
        if (!aeCaResult.error && aeCaResult.data) {
          companyAdminTotal = aeCaResult.data.totalUnread || 0;
          total += companyAdminTotal;
          if (aeCaResult.data.threadCounts) {
            aeCaResult.data.threadCounts.forEach(item => {
              counts[`company_admin_${item.threadId}`] = item.unreadCount || 0;
            });
          }
        }
        
        if (!generalResult.error && generalResult.data) {
          superAdminTotal = generalResult.data.totalUnread || 0;
          total += superAdminTotal;
        }
        
        setTotalUnreadCount(total);
        setLocalUnreadCounts(counts);
        
        // Dispatch to Redux for sidebar display (don't reset, just update if different)
        // Note: The global hook handles sidebar counts, so we don't dispatch here to avoid conflicts
      });
    }
  }, [token, aeCaApiService, generalApiService, dispatch]);

  // Load users when showing list
  useEffect(() => {
    if (showUserList && selectedChatType) {
      fetchUsers(selectedChatType, userSearchTerm);
    }
  }, [showUserList, selectedChatType]);

  // Handle incoming navigation state to auto-open chat with specific user
  useEffect(() => {
    if (location.state?.openChatWith && location.state?.chatType && !openChatProcessedRef.current) {
      console.log("📨 Received navigation state to open chat:", location.state);
      // Set the chat type immediately
      setSelectedChatType(location.state.chatType);
      setPendingChatUser({
        user: location.state.openChatWith,
        chatType: location.state.chatType
      });
      openChatProcessedRef.current = true;
      // Clear the state to prevent reopening on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  // When threads are loaded and we have a pending user, try to open/create chat
  useEffect(() => {
    if (pendingChatUser && !isLoadingThreads && aeCaApiService && selectedChatType) {
      const { user, chatType } = pendingChatUser;
      console.log("🔍 Processing pending chat user:", user, "chatType:", chatType);
      console.log("📋 Current chat list length:", chatList.length);
      
      // Check if a thread already exists with this user (use String for comparison)
      const existingThread = chatList.find(
        (c) => String(c.other_user_id) === String(user.id) && c.chatType === chatType
      );
      
      console.log("🔎 Found existing thread:", existingThread);
      
      if (existingThread) {
        // Thread exists, select it
        console.log("✅ Opening existing thread:", existingThread.id);
        setSelectedChat(existingThread);
        fetchMessages(existingThread.id, existingThread.chatType);
        setPendingChatUser(null);
      } else {
        // No existing thread, create a new one using startNewChat logic
        console.log("🆕 Creating new thread for user:", user);
        const workerData = {
          id: user.id,
          name: user.name,
          email: user.email,
        };
        
        // Call startNewChat - selectedChatType is already set
        startNewChat(workerData);
        setPendingChatUser(null);
      }
    }
  }, [pendingChatUser, chatList, isLoadingThreads, aeCaApiService, selectedChatType]);

  const filteredChats = chatList.filter((chat) =>
    chat.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );


  return (
    <Box sx={{ px: 1, mt: 1 }}>
               {fromDashboard && (
        <Box
          sx={{
            border: '1px solid #E4E6EF',
            borderRadius: 2,
            px: 2,
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            minHeight: 55,
            mb: 2
          }}
        >
          <Box
            sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
            onClick={() => navigate(-1)}
          >
            <img src={back} style={{ width: 30, height: 30 }} />
            <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 500,
                fontSize: '14px',
                color: '#626F86',
                textAlign: 'center'
              }}
            >
              {t('clientsTrialDetails.back')} 
            </CustomText>
          </Box>
        </Box>
      )}


      <Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
          height: { xs: 'auto', md: '80vh' },
    border: "2px solid #091E4224",
    borderRadius: 2,
    backgroundColor: "white",
  }}
>
        {/* Sidebar */}
  <Box
  sx={{
    width: { xs: '100%', md: 380 },
    borderRight: { xs: 'none', md: '1px solid #e0e0e0' },
    borderBottom: { xs: '1px solid #e0e0e0', md: 'none' },
    display: 'flex',
    flexDirection: 'column',
  }}
>
          {/* Header */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2 }}>
            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
              <CustomText sx={{ ...textStyles.h1, fontWeight: 500, fontSize: "22px", color: "#2C384C", textAlign: "left" }}>
              {t("messages_title")}
              </CustomText>
              {/* <img src={down} style={{ width: 17, height: 17 }} /> */}
              {totalUnreadCount > 0 && (
                <>
                  <Badge color="primary" badgeContent={totalUnreadCount} sx={{ ml: 2 }} />
                  <Tooltip title={t("Mark all as read")}>
                    <IconButton
                      onClick={markAllMessagesAsRead}
                      size="small"
                      sx={{
                        ml: 1,
                        backgroundColor: "#4CAF50",
                        color: "white",
                        width: 24,
                        height: 24,
                        "&:hover": { backgroundColor: "#388E3C" },
                      }}
                    >
                      <DoneAll sx={{ fontSize: 14 }} />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </Box>
            <IconButton
              sx={{
                backgroundColor: "#003149",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                p: 0.2,
                borderRadius: "50%",
                   '&:hover': {
      backgroundColor: "#003149", 
                }
              }}
              onClick={showUserList ? () => setShowUserList(false) : handleAddClick}
            >
              {showUserList ? (
                <ArrowBack sx={{ color: "white" }} />
              ) : (
              <Add sx={{ color: "white" }} />
              )}
            </IconButton>
          </Box>

          <Divider />

          {/* Search */}
          {!showUserList && (
          <Box sx={{ px: 1, py: 0.5 }}>
            <Box sx={{ px: 0.5, mt: 0.5, py: 0.4, borderRadius: 1, height: 34, border: '2px solid #091E4224', display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
            <InputBase
  placeholder={t("search_placeholder")}
  value={searchTerm}
                  onChange={(e) => {
                    const newSearchTerm = e.target.value;
                    setSearchTerm(newSearchTerm);
                    if (showUserList && selectedChatType) {
                      if (searchTimeoutRef.current) {
                        clearTimeout(searchTimeoutRef.current);
                      }
                      searchTimeoutRef.current = setTimeout(() => {
                        fetchUsers(selectedChatType, newSearchTerm);
                      }, 500);
                    }
                  }}
  sx={{ ml: 0.5, fontSize: 15, letterSpacing: "1px", color: "#939393", fontWeight: 500 }}
/>
              <SearchIcon sx={{ fontSize: 22, color: '#888', mr: 0.5 }} />
            </Box>
          </Box>
          )}

          {/* User list or chat list */}
          <Box sx={{ flexGrow: 1, overflowY: 'auto', px: 1 }}>
            <List>
              {isLoadingThreads && !showUserList ? (
                Array.from({ length: 5 }).map((_, index) => (
                  <ListItem key={index} sx={{ px: 1, py: 1 }}>
                    <ListItemAvatar>
                      <Skeleton variant="circular" width={40} height={40} />
                    </ListItemAvatar>
                    <ListItemText
                      primary={<Skeleton variant="text" width="60%" />}
                      secondary={<Skeleton variant="text" width="40%" />}
                    />
                  </ListItem>
                ))
              ) : !showThreads && !showUserList ? (
                <ListItem sx={{ px: 1, py: 1 }}>
                  <ListItemAvatar>
                    <Skeleton variant="circular" width={40} height={40} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={<Skeleton variant="text" width="60%" />}
                    secondary={<Skeleton variant="text" width="40%" />}
                  />
                </ListItem>
              ) : showUserList ? (
                isLoadingUsers ? (
                  Array.from({ length: 3 }).map((_, index) => (
                    <ListItem key={index} sx={{ px: 1, py: 1 }}>
                      <ListItemAvatar>
                        <Skeleton variant="circular" width={40} height={40} />
                      </ListItemAvatar>
                      <ListItemText
                        primary={<Skeleton variant="text" width="70%" />}
                        secondary={<Skeleton variant="text" width="50%" />}
                      />
                    </ListItem>
                  ))
                ) : (
                  userList.map((user) => (
<ListItem
                      key={user.id}
  button
                      onClick={() => startNewChat(user)}
                      sx={{
                        px: 1,
                        borderRadius: 2,
                        "&:hover": { backgroundColor: "#f5f5f5" },
  }}
>
  <ListItemAvatar>
                        <Box sx={{ position: 'relative' }}>
                          <Avatar
                            src={user.profile_image ? `${BASE_URL}/${user.profile_image}` : undefined}
                          >
                            {user.name?.charAt(0) || user.first_name?.charAt(0)}
                          </Avatar>
                          {getOnlineStatusIndicator(user.id)}
                        </Box>
  </ListItemAvatar>
  <ListItemText
                        primary={user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim()}
                        secondary={user.email}
    primaryTypographyProps={{
                          fontWeight: "600",
                          fontSize: "14px",
                          fontFamily: "Poppins, sans-serif",
    }}
    secondaryTypographyProps={{
                          fontSize: "13px",
                          color: "#5C5C5C",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      />
                    </ListItem>
                  ))
                )
              ) : (
                filteredChats.map((chat) => (
                  <ListItemButton
                    key={chat.id}
                    selected={selectedChat?.id === chat.id}
                    onClick={() => handleChatClick(chat)}
                    sx={{
                      px: 1,
                      borderRadius: 2,
                      backgroundColor: selectedChat?.id === chat.id ? '#F0F9FF' : 'transparent',
                      '&:hover': {
                        backgroundColor: selectedChat?.id === chat.id ? '#F0F9FF' : '#f5f5f5',
                      },
                    }}
                  >
                    <ListItemAvatar>
                      <Box sx={{ position: 'relative' }}>
                        <Avatar src={chat.icon || undefined}>
                          {chat.name?.charAt(0)}
                        </Avatar>
                        {getOnlineStatusIndicator(chat.other_user_id)}
                      </Box>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              color: selectedChat?.id === chat.id ? "#006EC2" : "#100F0F",
                              fontFamily: "Poppins, sans-serif",
                            }}
                          >
                            {chat.name}
                          </Typography>
                          {/* Role Badge */}
                          <Chip
                            label={getRoleBadgeLabel(chat.other_user_role, chat.chatType)}
                            size="small"
                            sx={{
                              height: '18px',
                              fontSize: '10px',
                              fontFamily: 'Poppins, sans-serif',
                              backgroundColor: getRoleBadgeColor(chat.other_user_role, chat.chatType).bg,
                              color: getRoleBadgeColor(chat.other_user_role, chat.chatType).text,
                              '& .MuiChip-label': { px: 0.8 },
                            }}
                          />
                        </Box>
                      }
                      secondary={
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}>
                          {/* Email Display */}
                          {chat.other_user_email && (
                            <Typography
                              sx={{
                                fontSize: "11px",
                                color: "#888",
                                fontFamily: "Poppins, sans-serif",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "150px",
                              }}
                            >
                              {chat.other_user_email}
                            </Typography>
                          )}
                          {/* Last Message */}
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            {chat.messageIcon === "image" && (
                              <Image sx={{ fontSize: 16, color: selectedChat?.id === chat.id ? "#006EC2" : "#666666" }} />
                            )}
                            {chat.messageIcon === "file" && (
                              <InsertDriveFile sx={{ fontSize: 16, color: selectedChat?.id === chat.id ? "#006EC2" : "#666666" }} />
                            )}
                            {chat.messageIcon === "audio" && (
                              <Mic sx={{ fontSize: 16, color: selectedChat?.id === chat.id ? "#006EC2" : "#666666" }} />
                            )}
                            {chat.msg && (
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  color: selectedChat?.id === chat.id ? "#006EC2" : "#666666",
                                  fontFamily: "Poppins, sans-serif",
                                  fontWeight: selectedChat?.id === chat.id ? "500" : "400",
                                }}
                              >
                                {chat.msg}
                              </Typography>
                            )}
                          </Box>
                          {/* {userOnlineStatus[chat.other_user_id] && (
                            <Typography
                              sx={{
                                fontSize: "11px",
                                color: userOnlineStatus[chat.other_user_id].isOnline ? "#4CAF50" : "#999",
                                fontFamily: "Poppins, sans-serif",
                                fontWeight: userOnlineStatus[chat.other_user_id].isOnline ? "500" : "400",
                              }}
                            >
                              {getOnlineStatusText(chat.other_user_id, chat.other_user_role || chat.chatType)}
                            </Typography>
                          )} */}
                        </Box>
                      }
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2.5 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          color: selectedChat?.id === chat.id ? "#006EC2" : "#666666",
                          fontWeight: selectedChat?.id === chat.id ? "500" : "400",
                        }}
                      >
      {chat.time}
    </Typography>
                      {(() => {
                        // Use only chat.unread_count to avoid double counting
                        const count = chat.unread_count || 0;
                        return count > 0 && (
                          <Box
                            sx={{
                              backgroundColor: "#006EC2",
                              color: "white",
                              borderRadius: "50%",
                              minWidth: "20px",
                              height: "20px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "11px",
                              fontWeight: "600",
                              fontFamily: "Poppins, sans-serif",
                            }}
                          >
                            {count}
                          </Box>
                        );
                      })()}
  </Box>
</ListItemButton>
                ))
              )}
            </List>
            
            {/* Load More Conversations Button */}
            {hasMoreThreads && !isLoadingThreads && filteredChats.length > 0 && (
              <Box sx={{ p: 1, textAlign: 'center' }}>
                <Button
                  onClick={loadMoreThreads}
                  disabled={isLoadingMoreThreads}
                  size="small"
                  sx={{
                    textTransform: 'none',
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: '12px',
                    color: '#006EC2',
                  }}
                >
                  {isLoadingMoreThreads ? (
                    <CircularProgress size={16} sx={{ mr: 1 }} />
                  ) : null}
               {isLoadingMoreThreads
? t("chat.roles.loading")
: t("chat.roles.loadMoreConversations")}
                </Button>
              </Box>
            )}
          </Box>
        </Box>

        {/* Right side - Chat area */}
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          {selectedChat && (
            <Box sx={{ px: 3, py: 1.2, borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                <Box sx={{ position: 'relative', mr: 2 }}>
                  <Avatar src={selectedChat.icon} />
                  {getOnlineStatusIndicator(selectedChat.other_user_id)}
                </Box>
                <Box>
                  <Typography sx={{ fontWeight: '600', fontSize: '16px', fontFamily: 'Poppins, sans-serif' }}>
                    {selectedChat.name}
                  </Typography>
                  <Typography
  sx={{
                      fontSize: '12px',
                      color: userOnlineStatus[selectedChat.other_user_id]?.isOnline ? '#4CAF50' : '#666',
                      fontFamily: 'Poppins, sans-serif',
                    }}
                  >
                    {userOnlineStatus[selectedChat.other_user_id]
                      ? getOnlineStatusText(selectedChat.other_user_id, selectedChat.other_user_role || selectedChat.chatType) ||
                        (userOnlineStatus[selectedChat.other_user_id].isOnline
                          ? (t('online') || 'Online')
                          : `${t('offline')}`
                        )
                      : ((selectedChat.other_user_role || selectedChat.chatType) === 'super_admin'
                          ? 'Super Admin'
                          : 'Company Admin'
                        )
                    }
                  </Typography>
            </Box>
          </Box>
              <IconButton onClick={() => setSelectedChat(null)}>
                <Close />
              </IconButton>
            </Box>
          )}
          

          {/* Messages */}
          <Box sx={{ flexGrow: 1, px: 3, py: 2, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 1 }}>
            {!selectedChat && (
              <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', color: "#5C5C5C" }}>
                <img crossOrigin="anonymous" src={chatimage} alt="chat" />
                <Typography sx={{ fontWeight: 600, fontSize: "18px", fontFamily: 'Poppins, sans-serif' }}>
                  {t('select_conversation_to_start')}
                </Typography>
                <Typography sx={{ fontSize: "14px", color: "#888", fontFamily: 'Poppins, sans-serif' }}>
                  {t('choose_conversation_or_start_new')}
                </Typography>
              </Box>
            )}

            {isLoadingMessages && selectedChat && (
              <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                <CircularProgress size={40} />
                <Typography sx={{ fontSize: "14px", color: "#888", fontFamily: 'Poppins, sans-serif' }}>
                  {t('loading_messages')}
                </Typography>
            </Box>
            )}

            {/* Load Older Messages Button */}
            {selectedChat && !isLoadingMessages && messages.length > 0 && (
              <Box sx={{ textAlign: 'center', py: 1 }}>
                {hasMoreMessages ? (
                  <Button
                    onClick={loadMoreMessages}
                    disabled={isLoadingMoreMessages}
                    size="small"
                    startIcon={isLoadingMoreMessages ? <CircularProgress size={14} /> : <KeyboardArrowUp />}
                    sx={{
                      textTransform: 'none',
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: '12px',
                      color: '#006EC2',
                    }}
                  >
                    {isLoadingMoreMessages ? t('Loading...') : t('Load Older Messages')}
                  </Button>
                ) : (
                  <Typography sx={{ fontSize: '12px', color: '#999', fontFamily: 'Poppins, sans-serif' }}>
                    {t('Beginning of conversation')}
                  </Typography>
                )}
              </Box>
            )}

            {selectedChat && messages.map((msg) => {
              const isMine = msg.sender_id === userId || msg.sender?.id === userId;
              return (
                <Box
                  key={msg.id || msg.tempId}
                  sx={{
                    alignSelf: isMine ? "flex-end" : "flex-start",
                    maxWidth: "70%",
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0.5,
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: isMine ? "#006EC2" : "#F0F9FF",
                      color: isMine ? "white" : "#2C3E50",
                      borderRadius: 2,
                      px: 2,
                      py: 0.5,
                    }}
                  >
                    {msg.message_type === "text" ? (
                      <Typography sx={{ fontSize: "13px", fontFamily: 'Poppins, sans-serif' }}>
                        {msg.content}
                      </Typography>
                    ) : msg.message_type === "image" ? (
                      <Box>
                        {msg.content && msg.content !== "File shared" && (
                          <Typography sx={{ fontSize: "13px", fontFamily: 'Poppins, sans-serif', mb: 1 }}>
                            {msg.content}
                          </Typography>
                        )}
                        {msg.file_url && (() => {
                          const imageUrl = getFileUrl(msg.file_url);
                          return (
                            <img
                              crossOrigin="anonymous"
                              src={imageUrl}
                              alt={msg.file_name || "Image"}
                              style={{ 
                                width: "120px", 
                                height: "120px",
                                maxWidth: "100%",
                                borderRadius: 8, 
                                objectFit: "cover",
                                cursor: "pointer",
                                display: "block",
                                marginTop: msg.content ? 8 : 0
                              }}
                              onClick={() => {
                                // Open image in new tab
                                if (imageUrl) {
                                  window.open(imageUrl, '_blank');
                                }
                              }}
                            />
                          );
                        })()}
                      </Box>
                    ) : ((msg.message_type === "audio" && msg.file_url) || ((msg.message_type === "system" || msg.message_type === "file") && msg.file_url)) ? (
                      // Show audio player when message_type is "audio" or legacy file with audio type
                      (() => {
                        const isAudioMessage = 
                          msg.message_type === "audio" ||
                          msg.file_type?.startsWith('audio/') || 
                          msg.mime_type?.startsWith('audio/') ||
                          msg.file_name === "audio.webm" ||
                          msg.file_name?.endsWith('.webm') ||
                          msg.file_url?.includes('audio');
                        return isAudioMessage && msg.file_url;
                      })() ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25, minWidth: 260 }}>
                          {msg.content && msg.content !== "File shared" && (
                            <Typography sx={{ fontSize: "13px", fontFamily: 'Poppins, sans-serif', mb: 0.5 }}>
                              {msg.content}
                            </Typography>
                          )}
                          <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                            minHeight: 56,
                            py: 1.5,
                            px: 1,
                            borderRadius: 1.5,
                          }}>
                            <IconButton
                              size="small"
                              onClick={() => toggleAudioPlayback(msg.id, msg.file_url)}
                              sx={{
                                color: isMine ? "white" : "#006EC2",
                                bgcolor: isMine ? "rgba(255,255,255,0.2)" : "rgba(0,110,194,0.1)",
                                '&:hover': {
                                  bgcolor: isMine ? "rgba(255,255,255,0.3)" : "rgba(0,110,194,0.2)",
                                }
                              }}
                            >
                              {playingAudioId === msg.id ? (
                                <Pause sx={{ fontSize: 22 }} />
                              ) : (
                                <PlayArrow sx={{ fontSize: 22 }} />
                              )}
                            </IconButton>
                            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                              <Box
                                sx={{
                                  width: '100%',
                                  height: 6,
                                  bgcolor: isMine ? "rgba(255,255,255,0.3)" : "rgba(0,110,194,0.2)",
                                  borderRadius: 2,
                                  overflow: 'hidden',
                                }}
                              >
                                <Box
                                  sx={{
                                    width: audioProgressById[msg.id]?.duration
                                      ? `${(audioProgressById[msg.id].current / audioProgressById[msg.id].duration) * 100}%`
                                      : '0%',
                                    height: '100%',
                                    bgcolor: isMine ? "white" : "#006EC2",
                                    transition: 'width 0.1s linear',
                                  }}
                                />
                              </Box>
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  fontFamily: 'Poppins, sans-serif',
                                  mt: 0.75,
                                  color: isMine ? "rgba(255,255,255,0.9)" : "#666",
                                }}
                              >
                                {audioProgressById[msg.id]?.duration
                                  ? `${formatDuration(Math.floor(audioProgressById[msg.id].current))} / ${formatDuration(Math.floor(audioProgressById[msg.id].duration))}`
                                  : '0:00 / 0:00'}
                              </Typography>
                            </Box>
                            <IconButton
                              size="small"
                              onClick={() => downloadFile(msg.file_url, msg.file_name || "audio.webm")}
                              sx={{ color: isMine ? "white" : "#006EC2" }}
                            >
                              <Download sx={{ fontSize: 18 }} />
                            </IconButton>
                          </Box>
                        </Box>
                      ) : (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Description sx={{ fontSize: 24 }} />
                          <Box>
                            <Typography sx={{ fontSize: "13px", fontFamily: 'Poppins, sans-serif', fontWeight: 600 }}>
                              {msg.file_name || "Document"}
                            </Typography>
                            {msg.content && msg.content !== "File shared" && (
                              <Typography sx={{ fontSize: "12px", fontFamily: 'Poppins, sans-serif', mt: 0.5 }}>
                                {msg.content}
                              </Typography>
                            )}
                            <IconButton
                              size="small"
                              onClick={() => downloadFile(msg.file_url, msg.file_name)}
                              sx={{ mt: 0.5, color: isMine ? "white" : "#006EC2" }}
                            >
                              <Download sx={{ fontSize: 16 }} />
                            </IconButton>
                          </Box>
                        </Box>
                      )
                    ) : (
                      <Typography sx={{ fontSize: "13px", fontFamily: 'Poppins, sans-serif' }}>
                        {msg.content}
                      </Typography>
                    )}
                  </Box>
                  {msg.created_at && (
                    <Typography
                      sx={{
                        fontSize: "10px",
                        color: "#999",
                        fontFamily: 'Poppins, sans-serif',
                        alignSelf: isMine ? "flex-end" : "flex-start",
                        px: 1,
                      }}
                    >
                      {formatMessageTime(msg.created_at)}
                    </Typography>
                  )}
                </Box>
              );
            })}
            <div ref={messagesEndRef} />
          </Box>

          {/* Input area */}
          {selectedChat && (
            <>
          <Divider />
          <Box sx={{ display: 'flex', alignItems: 'center', px: 2, py: 1 }}>
                <input
                  type="file"
                  accept="image/*,.pdf,.doc,.docx,.txt,.xls,.xlsx,.ppt,.pptx"
                  onChange={handleFileSelect}
                  style={{ display: 'none' }}
                  id="file-upload"
                />
                <label htmlFor="file-upload">
                  <IconButton 
                    component="span" 
                    sx={{ color: "#44546F" }}
                    disabled={isRecording || isUploadingAudio}
                  >
                    <AttachFile />
                  </IconButton>
                </label>
                {/* Audio recording button */}
                {isRecording ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 1 }}>
                    <IconButton
                      onClick={stopRecording}
                      sx={{
                        color: "#fff",
                        bgcolor: "#f44336",
                        '&:hover': { bgcolor: "#d32f2f" }
                      }}
                    >
                      <Stop />
                    </IconButton>
                    <Typography sx={{ fontSize: "14px", fontFamily: 'Poppins, sans-serif', color: "#f44336", fontWeight: 600 }}>
                      {formatDuration(recordingDuration)}
                    </Typography>
                  </Box>
                ) : (
                  <IconButton
                    onClick={startRecording}
                    disabled={isUploadingAudio || isUploadingImage || isUploadingFile}
                    sx={{ color: "#44546F" }}
                  >
                    <Mic />
                  </IconButton>
                )}
                {(imagePreview || uploadedImageUrl) && (
                  <Box sx={{ position: 'relative', mr: 1 }}>
                    {isUploadingImage ? (
                      <Box sx={{ width: 50, height: 50, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #E0E0E0', borderRadius: 1 }}>
                        <CircularProgress size={20} />
                      </Box>
                    ) : (
                      <img src={imagePreview || uploadedImageUrl} alt="Preview" style={{ width: 50, height: 50, borderRadius: 4 }} />
                    )}
                    <IconButton
                      size="small"
                      onClick={clearUploadedImage}
                      sx={{ position: 'absolute', top: -8, right: -8, bgcolor: 'white' }}
                    >
                      <Close sx={{ fontSize: 16 }} />
                    </IconButton>
                  </Box>
                )}
                {(selectedFile || uploadedFileUrl) && (
                  <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
                    {isUploadingFile ? (
                      <CircularProgress size={20} sx={{ mr: 1 }} />
                    ) : (
                      <Description sx={{ fontSize: 20, color: "#44546F" }} />
                    )}
                    <Typography sx={{ fontSize: 12, ml: 0.5, color: "#44546F" }}>
                      {selectedFile?.name || 'Document'}
                    </Typography>
                    {!isUploadingFile && (
                      <IconButton size="small" onClick={clearUploadedFile}>
                        <Close sx={{ fontSize: 16 }} />
                      </IconButton>
                    )}
                  </Box>
                )}
                {(uploadedAudioUrl || audioUrl) && (
                  <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
                    {isUploadingAudio ? (
                      <CircularProgress size={20} sx={{ mr: 1 }} />
                    ) : (
                      <Mic sx={{ fontSize: 20, color: "#44546F" }} />
                    )}
                    <Typography sx={{ fontSize: 12, ml: 0.5, color: "#44546F" }}>
                      {formatDuration(recordingDuration) || 'Audio'}
                    </Typography>
                    {!isUploadingAudio && (
                      <IconButton size="small" onClick={clearUploadedAudio}>
                        <Close sx={{ fontSize: 16 }} />
                      </IconButton>
                    )}
                  </Box>
                )}
           <Box sx={{ position: 'relative', flexGrow: 1, mx: 2 }}>
  <input
    className="project_input"
    placeholder={t("type_message_placeholder")}
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        handleSendMessage();
                      }
                    }}
    style={{
      width: '100%',
      padding: '10px 40px 10px 12px',
      fontSize: '15px',
      fontFamily: 'Poppins, sans-serif',
    }}
  />
  <IconButton
                    onClick={handleSendMessage}
                    disabled={isSendingMessage || isUploadingImage || isUploadingFile || isUploadingAudio || isRecording || (!newMessage.trim() && !uploadedImageUrl && !uploadedFileUrl && !uploadedAudioUrl)}
    sx={{
      position: 'absolute',
      right: 6,
      top: '50%',
      transform: 'translateY(-50%)',
      padding: 0,
    }}
  >
                    {isSendingMessage ? (
                      <CircularProgress size={20} />
                    ) : (
                      <img src={send} alt="send" />
                    )}
  </IconButton>
</Box>
          </Box>
            </>
          )}
        </Box>
      </Box>

      {/* Dialog for selecting chat type and user */}
      <Dialog
        open={showUserDialog}
        onClose={handleDialogClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: "80vh",
          }
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {selectedRole && (
              <IconButton
                onClick={() => {
                  setSelectedRole(null);
                  setUserList([]);
                  setUserSearchTerm("");
                }}
                size="small"
                sx={{
                  color: "#666",
                  mr: 1,
                }}
              >
                <ArrowBack />
              </IconButton>
            )}
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "20px",
                fontFamily: "Poppins, sans-serif",
                color: "#2C384C",
              }}
            >
              {selectedRole 
                ? `${selectedRole === "super_admin" ? t("Super Admin") : t("Company Admin")} - ${t("Select User")}`
                : t("Select User Type")}
            </Typography>
          </Box>
          <IconButton
            onClick={handleDialogClose}
            size="small"
            sx={{
              color: "#666",
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          {!selectedRole ? (
            // Role Selection Step
            <Box sx={{ p: 2 }}>
              <List>
                <ListItem
                  button
                  onClick={() => handleSelectRole("super_admin")}
                  sx={{
                    borderRadius: 2,
                    mb: 1,
                    border: "1px solid #E3F2FD",
                    backgroundColor: "#F5FAFF",
                    "&:hover": { backgroundColor: "#E3F2FD" },
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "16px",
                          fontFamily: "Poppins, sans-serif",
                          color: "#1976D2",
                        }}
                      >
                        {t("Super Admin")}
                      </Typography>
                    }
                    secondary={
                      <Typography
                        sx={{
                          fontSize: "13px",
                          color: "#666",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      >
                        {t("Select a Super Admin to chat with")}
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem
                  button
                  onClick={() => handleSelectRole("company_admin")}
                  sx={{
                    borderRadius: 2,
                    mb: 1,
                    border: "1px solid #F3E5F5",
                    backgroundColor: "#FBF5FF",
                    "&:hover": { backgroundColor: "#F3E5F5" },
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "16px",
                          fontFamily: "Poppins, sans-serif",
                          color: "#7B1FA2",
                        }}
                      >
                        {t("Company Admin")}
                      </Typography>
                    }
                    secondary={
                      <Typography
                        sx={{
                          fontSize: "13px",
                          color: "#666",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      >
                        {t("Select a Company Admin to chat with")}
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Box>
          ) : (
            // User Selection Step
            <>
              {/* Search in Dialog */}
              <Box sx={{ px: 2, pb: 1 }}>
                <Box
                  sx={{
                    px: 1,
                    py: 0.5,
                    borderRadius: 1,
                    height: 40,
                    border: "2px solid #091E4224",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <InputBase
                    placeholder={t("search_placeholder")}
                    value={userSearchTerm}
                    onChange={(e) => {
                      const newSearchTerm = e.target.value;
                      setUserSearchTerm(newSearchTerm);
                      // Debounce search - fetch after user stops typing
                      if (selectedRole) {
                        if (searchTimeoutRef.current) {
                          clearTimeout(searchTimeoutRef.current);
                        }
                        searchTimeoutRef.current = setTimeout(() => {
                          fetchUsers(selectedRole === 'super_admin' ? 'super_admin' : 'company_admin', newSearchTerm);
                        }, 500);
                      }
                    }}
                    sx={{
                      ml: 0.5,
                      fontSize: 15,
                      color: "#939393",
                      fontWeight: 500,
                      flex: 1,
                    }}
                  />
                  <SearchIcon sx={{ fontSize: 22, color: "#888", mr: 0.5 }} />
                </Box>
              </Box>
              {/* Select All Checkbox (only for Company Admin) */}
              {selectedRole === 'company_admin' && userList.length > 0 && (
                <Box sx={{ px: 2, pb: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Checkbox
                      checked={
                        userList.filter((user) => {
                          const name = user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim();
                          const email = user.email || '';
                          const searchLower = userSearchTerm.toLowerCase();
                          return name.toLowerCase().includes(searchLower) || email.toLowerCase().includes(searchLower);
                        }).length > 0 &&
                        userList
                          .filter((user) => {
                            const name = user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim();
                            const email = user.email || '';
                            const searchLower = userSearchTerm.toLowerCase();
                            return name.toLowerCase().includes(searchLower) || email.toLowerCase().includes(searchLower);
                          })
                          .every((user) => selectedUsers.includes(user.id))
                      }
                      indeterminate={
                        userList
                          .filter((user) => {
                            const name = user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim();
                            const email = user.email || '';
                            const searchLower = userSearchTerm.toLowerCase();
                            return name.toLowerCase().includes(searchLower) || email.toLowerCase().includes(searchLower);
                          })
                          .some((user) => selectedUsers.includes(user.id)) &&
                        !userList
                          .filter((user) => {
                            const name = user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim();
                            const email = user.email || '';
                            const searchLower = userSearchTerm.toLowerCase();
                            return name.toLowerCase().includes(searchLower) || email.toLowerCase().includes(searchLower);
                          })
                          .every((user) => selectedUsers.includes(user.id))
                      }
                      onChange={(e) => handleSelectAll(e.target.checked)}
                      sx={{ p: 0.5 }}
                    />
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 500,
                        fontFamily: "Poppins, sans-serif",
                        color: "#2C384C",
                      }}
                    >
                      {t("Select All")}
                    </Typography>
                  </Box>
                </Box>
              )}

              {/* User List in Dialog */}
              <Box sx={{ maxHeight: "60vh", overflowY: "auto", px: 1 }}>
                <List>
                  {isLoadingUsers ? (
                    // Loading skeleton for users
                    Array.from({ length: 5 }).map((_, index) => (
                      <ListItem key={index} sx={{ px: 1, py: 1 }}>
                        <ListItemAvatar>
                          <Skeleton variant="circular" width={40} height={40} />
                        </ListItemAvatar>
                        <ListItemText
                          primary={<Skeleton variant="text" width="70%" />}
                          secondary={<Skeleton variant="text" width="50%" />}
                        />
                      </ListItem>
                    ))
                  ) : userList.length === 0 ? (
                    <ListItem>
                      <ListItemText
                        primary={
                          <Typography
                            sx={{
                              textAlign: "center",
                              color: "#999",
                              fontFamily: "Poppins, sans-serif",
                            }}
                          >
                            {t("No users available")}
                          </Typography>
                        }
                      />
                    </ListItem>
                  ) : (
                    userList
                      .filter((user) => {
                        const name = user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim();
                        const email = user.email || '';
                        const searchLower = userSearchTerm.toLowerCase();
                        return name.toLowerCase().includes(searchLower) || email.toLowerCase().includes(searchLower);
                      })
                      .map((user) => {
                        const isSelected = selectedUsers.includes(user.id);
                        const isCompanyAdmin = selectedRole === 'company_admin';
                        
                        return (
                          <ListItem
                            key={user.id}
                            button={!isCompanyAdmin}
                            onClick={() => {
                              if (isCompanyAdmin) {
                                toggleUserSelection(user.id);
                              } else {
                                startNewChat(user);
                                handleDialogClose();
                              }
                            }}
                            sx={{
                              px: 1,
                              borderRadius: 2,
                              mb: 0.5,
                              backgroundColor: isCompanyAdmin && isSelected ? "#E3F2FD" : "transparent",
                              "&:hover": { backgroundColor: isCompanyAdmin && isSelected ? "#E3F2FD" : "#f5f5f5" },
                            }}
                          >
                            {isCompanyAdmin && (
                              <Checkbox
                                checked={isSelected}
                                onChange={() => toggleUserSelection(user.id)}
                                onClick={(e) => e.stopPropagation()}
                                sx={{ mr: 1 }}
                              />
                            )}
                            <ListItemAvatar>
                              <Box sx={{ position: 'relative' }}>
                                <Avatar
                                  src={
                                    user.profile_image
                                      ? (user.profile_image.startsWith('http://') || user.profile_image.startsWith('https://'))
                                        ? user.profile_image
                                        : `${BASE_URL}${user.profile_image.startsWith('/') ? user.profile_image.substring(1) : user.profile_image}`
                                      : undefined
                                  }
                                >
                                  {user.name?.charAt(0) || user.first_name?.charAt(0)}
                                </Avatar>
                                {getOnlineStatusIndicator(user.id)}
                              </Box>
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <Typography
                                  sx={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    fontFamily: "Poppins, sans-serif",
                                  }}
                                >
                                  {user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim()}
                                </Typography>
                              }
                              secondary={user.email}
                              secondaryTypographyProps={{
                                fontSize: "13px",
                                color: "#5C5C5C",
                                fontFamily: "Poppins, sans-serif",
                              }}
                            />
                          </ListItem>
                        );
                      })
                  )}
                </List>
              </Box>
            </>
          )}
        </DialogContent>
        
        {/* Dialog Footer with Message Input and Action Buttons (only for Company Admin with selections) */}
        {selectedRole === 'company_admin' && selectedUsers.length > 0 && (
          <DialogActions sx={{ flexDirection: 'column', px: 2, pb: 2, gap: 1 }}>
            {/* User count text */}
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Poppins, sans-serif",
                  color: "#666",
                }}
              >
                {t("Send message to")} {selectedUsers.length} {selectedUsers.length === 1 ? t("user") : t("users")}
              </Typography>
              <Typography
                onClick={handleClearSelection}
                sx={{
                  fontSize: "13px",
                  fontFamily: "Poppins, sans-serif",
                  color: "#006EC2",
                  cursor: "pointer",
                  textDecoration: "underline",
                  "&:hover": { color: "#0056b3" },
                }}
              >
                {t("Clear selection")}
              </Typography>
            </Box>

            {/* Message Input */}
            <Box sx={{ width: '100%', position: 'relative' }}>
              <InputBase
                placeholder={t("Type your message here...")}
                value={bulkMessageText}
                onChange={(e) => setBulkMessageText(e.target.value)}
                multiline
                maxRows={3}
                sx={{
                  width: '100%',
                  px: 1.5,
                  py: 1,
                  borderRadius: 1,
                  border: "1px solid #E0E0E0",
                  fontSize: "14px",
                  fontFamily: "Poppins, sans-serif",
                  "&:focus-within": {
                    borderColor: "#006EC2",
                  },
                }}
              />
            </Box>

            {/* Action Buttons */}
            <Box sx={{ width: '100%', display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
              {selectedUsers.length === 1 ? (
                // Start Chat button for single user
                <Button
                  variant="contained"
                  onClick={() => {
                    const selectedUser = userList.find((u) => u.id === selectedUsers[0]);
                    if (selectedUser) {
                      startNewChat(selectedUser);
                      handleDialogClose();
                    }
                  }}
                  sx={{
                    backgroundColor: "#006EC2",
                    color: "white",
                    textTransform: "none",
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 500,
                    px: 3,
                    "&:hover": {
                      backgroundColor: "#0056b3",
                    },
                  }}
                >
                  {t("Start Chat")}
                </Button>
              ) : (
                // SEND button for multiple users
                <Button
                  variant="contained"
                  onClick={handleBulkSendMessage}
                  disabled={!bulkMessageText.trim() || isSendingBulkMessage}
                  startIcon={isSendingBulkMessage ? <CircularProgress size={16} color="inherit" /> : <Send />}
                  sx={{
                    backgroundColor: "#006EC2",
                    color: "white",
                    textTransform: "none",
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 500,
                    px: 3,
                    "&:hover": {
                      backgroundColor: "#0056b3",
                    },
                    "&:disabled": {
                      backgroundColor: "#E0E0E0",
                      color: "#999",
                    },
                  }}
                >
                  {t("SEND")}
                </Button>
              )}
            </Box>
          </DialogActions>
        )}
      </Dialog>
    </Box>
  );
};

export default Messages;

